import { createTheme } from '@mui/material';

/** Media query for phones: below MUI's `sm` breakpoint. */
export const PHONE_QUERY = '(max-width:599px)';

/** App-wide theme: sentence-case buttons read calmer than the MUI all-caps default. */
export const appTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});
